<template>
  <div
    id="app"
    v-loading="{
      loading: loadingStore.isLoading,
      size: 'lg',
      title: loadingStore.loadingTitle,
      subtitle: loadingStore.loadingSubtitle,
    }"
  >
    <router-view :key="$route.fullPath" />
    <div id="message-box"></div>
  </div>
</template>

<script setup>
/**
 * App.vue — Root component của Merchant UI
 * Vue 3 Composition API (script setup)
 * v-loading directive từ MISA UI Control — bind vào LoadingStore để hiển thị loading toàn trang
 * CreatedBy: dbhuan (14/06/2026)
 * UpdatedBy: dbhuan (14/06/2026) — tich hop v-loading directive thay DOM #mloading
 */
import { useLoadingStore } from "@/stores/LoadingStore";
import { useRoute } from "vue-router";

const loadingStore = useLoadingStore();
const $route = useRoute();
</script>
